/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from 'react';

import {
  Form,
  Input,
  InputNumber,
  Layout,
  message,
  Row,
  Typography,
} from 'antd';
import { identity, uniqueId, get } from 'lodash';

import { OverlayLoading } from 'components/overlay-loading';
import PdButton from 'components/pd-button';

import { errHandling } from 'utils';
import {
  priceInputNumberFormatter,
  priceInputNumberParser,
} from 'utils/inputNumber.js';

import './style.scss';

const { Content } = Layout;
const { Title } = Typography;
const { TextArea } = Input;

const FIELDS = {
  DESCRIPTION: 'description',
  PENALTY: 'price',
  TITLE: 'title',
};

export function PenaltyCreateEdit({
  closeModal = identity,
  penalty = {},
  product_id,
  setPenaltyList,
}) {
  const [form] = Form.useForm();
  const [loadingButton, setLoadingButton] = useState(false);
  const [loadingPage, setLoadingPage] = useState(false);
  const [value, setValue] = useState({});

  const { id: penaltyId, tempId } = penalty;

  const formItemLayout = {
    labelCol: { span: 5 },
    wrapperCol: { span: 16, offset: 2 },
    labelAlign: 'left',
  };

  async function handleSubmit(values) {
    setLoadingButton(true);
    try {
      const payload = { ...values, product_id };
      if (penaltyId || tempId) {
        const key = penaltyId ? 'id' : 'tempId';
        setPenaltyList((prev) => {
          const filtered = prev.filter(
            (singlePenalty) => singlePenalty[key] !== penalty[key]
          );
          return [{ ...payload, [key]: penalty[key] }, ...filtered];
        });
      } else {
        setPenaltyList((prev) => [
          ...prev,
          { ...values, tempId: uniqueId('TEMP_') },
        ]);
      }
      message.success(
        penaltyId || tempId
          ? 'Successfully edit penalty hit publish to save your work'
          : 'Successfully add new penalty hit publish to save your work'
      );
      closeModal();
    } catch (err) {
      errHandling(err);
    } finally {
      setLoadingButton(false);
    }
  }

  useEffect(() => {
    setValue(penalty);
    form.setFieldsValue(penalty);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Content>
      {loadingPage && <OverlayLoading open={loadingPage} />}
      <Form
        form={form}
        className="pd-risk-management-form"
        onFinish={handleSubmit}
        initialValues={value}>
        <div className="section-container">
          <Row className="pd-margin-bottom-lg" type="flex" justify="center">
            <Title level={4}>Add New List</Title>
          </Row>
          <div className="inner-section">
            <Form.Item
              label="List"
              name={FIELDS.TITLE}
              rules={[
                {
                  message: 'Please input list title!',
                  required: true,
                },
                {
                  validator: (_, value) => {
                    if (value && value.toLowerCase() === 'other') {
                      return Promise.reject(
                        new Error('Cannot create other damage')
                      );
                    }
                    return Promise.resolve();
                  },
                },
              ]}
              {...formItemLayout}>
              <Input
                disabled={
                  penaltyId !== undefined &&
                  get(value, FIELDS.TITLE, '').toLowerCase() === 'other'
                }
                placeholder="Input list title here"
              />
            </Form.Item>

            <Form.Item
              label="Description"
              name={FIELDS.DESCRIPTION}
              rules={[
                {
                  message: 'Please input description!',
                  required: true,
                },
              ]}
              {...formItemLayout}>
              <TextArea
                placeholder="Write your description"
                autoSize={{ minRows: 5 }}
              />
            </Form.Item>

            <Form.Item
              label="Penalty Price"
              name={FIELDS.PENALTY}
              rules={[
                {
                  message: 'Please input the penalty price!',
                  required: true,
                },
              ]}
              {...formItemLayout}>
              <InputNumber
                className="w-full"
                formatter={priceInputNumberFormatter}
                parser={priceInputNumberParser}
              />
            </Form.Item>
          </div>
        </div>

        <div className="button-container">
          <Form.Item>
            <Row type="flex" justify="center">
              <PdButton
                className="w-half height-32"
                full
                htmlType="submit"
                loading={loadingButton}
                type="primary">
                Save
              </PdButton>
            </Row>
          </Form.Item>
        </div>
      </Form>
    </Content>
  );
}
